export const KEY_CODES = {
  ESCAPE: 'Escape',
  TAB: 'Tab',
  SPACE: ' ',
  ENTER: 'Enter',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  RIGHT_ARROW: 'ArrowRight',
  LEFT_ARROW: 'ArrowLeft',
};

export const DEVICE_WIDTH = {
  mobile: '767px',
  tablet: '1023px',
  smallDesktop: '1200px',
};

export const MOBILE_BREAKPOINT = { width: 430, height: 932, name: 'mobile' };
export const TABLET_BREAKPOINT = { width: 767, height: 1024, name: 'tablet' };
export const SMALL_DESKTOP_BREAKPOINT = { width: 1024, height: 1366, name: 'small-desktop' };
export const DESKTOP_BREAKPOINT = { width: 1600, height: 929, name: 'desktop' };

export const VISUAL_TEST_BREAKPOINTS = [
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  SMALL_DESKTOP_BREAKPOINT,
  DESKTOP_BREAKPOINT,
];

export const VISUAL_TEST_THEMES = [
  { name: 'dsg', headerCode: '111' },
  { name: 'gg', headerCode: '121' },
  { name: 'pl', headerCode: '161' },
];

export const VISUAL_TEST_AOS_THEMES = [
  { name: 'dsgaos', headerCode: '112' },
  { name: 'ggaos', headerCode: '125' },
  { name: 'plaos', headerCode: '162' },
];

export const VISUAL_TEST_LOWER_BRAND_THEMES = [
  { name: 'plf', headerCode: '163' },
  { name: 'g3', headerCode: '171' },
];

export const FEATURE_CONFIGURATION_KEYS = {
  MODIFY_TICKER: 'modifyTicker',
};

export const PERSONALIZATION_DATA_KEYS = {
  MODIFY_TRENDING_SEARCHES: 'modifyTrendingSearches',
};

export const PERSONALIZATION_SERVICE = 'PersonalizationService';
